import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
 
  
  
  width: 100%;

  overflow-y: scroll;
  max-height: 60vh;
  &::-webkit-scrollbar {
    width: 0.6vw;
    height: 0.6vw;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.dark}; /* color of the scroll thumb */
    border-radius: 0.25rem; /* roundness of the scroll thumb */
    height: 2px;
  }
`;

export const Button = styled.button`
  background-color: ${theme.colors.light};
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  color: ${theme.colors.dark};

  &:hover {
    opacity: 0.8;
  }
  font-size: max(10px, 1.2vw);
  white-space: nowrap;
  margin-top: 2vh;
`;

export const Span = styled.span`
  white-space: nowrap;
  font-size: max(6px, 0.8vw);
`;

export const HandleSpan = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Title = styled.h1`
  font-size: max(12px, 1.4vw);
  text-align: center;
  color: ${theme.colors.dark};
`;
